<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType" style="height:calc( 100% - 100px )">
        <div class="write-txt">
          <p class="write-title">模块<span>*</span></p>
          <div class="write-text">
            <input type="text" placeholder="请输入模块名称" v-model="addObj.title">
            <!-- <el-select v-model="addObj.speech_type" placeholder="请选择" @change="speechChange">
              <el-option
                v-for="item in speechlist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">关卡类型:<span>*</span></p>
          <div class="write-text">
            <el-radio-group v-model="addObj.type">
              <el-radio label="1">自由型</el-radio>
              <el-radio label="0">解锁型</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title">是否免费:<span>*</span></p>
          <div class="write-text" style="width:50%;">
            <el-radio-group v-model="addObj.is_vip">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="write-txt">
          <p class="write-title">排序<span>*</span></p>
          <div class="write-text">
            <input type="number" v-model="addObj.sort">
          </div>
        </div>
        
        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="MobelBox wordBox" v-else-if="wordType">
        <button class="btn btn-back" @click="closeSub">返回</button>
        <div style="display:block;">
          <div class="write-num" :class="levelIndex==index?'select':''"  v-for="(item,index) in levelObj" :key="index" @click="levelNum(index)">
            <p>关卡{{(index+1)}}</p>
          </div>
          <button class="btn btn-level" @click="levelAdd">+添加关卡</button>
        </div>
        <div v-for="(item,index) in levelObj" :key="index" v-if="levelIndex==index" style="display:block;">
          <!-- <div class="write-num">
            <p>关卡{{(index+1)}}</p>
            <button class="btn btn-level" @click="levelSub">+添加关卡</button>
          </div> -->
          <div class="write-txt">
            <p class="write-title">关卡类型:<span>*</span></p>
            <div class="write-text">
              <el-radio-group v-model="item.speech_type" @change="speechChnage(item,$event,index)">
                <el-radio :label="ele.id" v-for="ele in speechType" :key="ele.id">{{ele.title}}</el-radio>
              </el-radio-group>
            </div>
          </div>
          
          <div style="display:block;" v-if="item.speech_type == 7">
            <div class="write-txt">
              <p class="write-title">关卡标题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入关卡标题" v-model="item.level_title" style="height:140px;"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">演讲主题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入演讲主题" v-model="item.title" style="height:140px;"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">演讲内容:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入演讲内容" v-model="item.speech_cont"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">倒计时设置:<span>*</span></p>
              <div class="write-text">
                <input type="text" placeholder="请输入秒" v-model="item.preparation_time">
                <p>秒</p>
              </div>
            </div><div class="write-txt">
              <p class="write-title">演讲时长:<span>*</span></p>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入分钟" v-model="item.min_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.min_second">
                <p>秒</p>
              </div>
              <div class="write-text write-time">
                <!-- <input type="text" placeholder="请输入秒" style="opacity:0;"> -->
                <p style="line-height:65px">——</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_second">
                <p>秒</p>
              </div>
            </div>
          </div>

          <div style="display:block;" v-else-if="item.speech_type == 3">
            <div class="write-txt">
              <p class="write-title">关卡标题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入关卡标题" v-model="item.level_title" style="height:140px;"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">倒计时设置:<span>*</span></p>
              <div class="write-text">
                <input type="text" placeholder="请输入秒" v-model="item.preparation_time">
                <p>秒</p>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">演讲时长:<span>*</span></p>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入分钟" v-model="item.min_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.min_second">
                <p>秒</p>
              </div>
              <div class="write-text write-time">
                <!-- <input type="text" placeholder="请输入秒" style="opacity:0;"> -->
                <p style="line-height:65px">——</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_second">
                <p>秒</p>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">每日一词:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入每日一词" v-model="item.keyword" style="height:140px;"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">演讲时隐藏标题和演讲内容:<span>*</span></p>
              <div class="write-text">
                <el-radio-group v-model="item.is_hide">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div style="display:block;" v-else-if="item.speech_type == 4">
            <div class="write-txt">
              <p class="write-title">关卡标题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入关卡标题" v-model="item.level_title" style="height:140px;"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">演讲主题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入演讲主题" v-model="item.title" style="height:140px;"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">倒计时设置:<span>*</span></p>
              <div class="write-text">
                <input type="text" placeholder="请输入秒" v-model="item.preparation_time">
                <p>秒</p>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">演讲时长:<span>*</span></p>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入分钟" v-model="item.min_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.min_second">
                <p>秒</p>
              </div>
              <div class="write-text write-time">
                <!-- <input type="text" placeholder="请输入秒" style="opacity:0;"> -->
                <p style="line-height:65px">——</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_second">
                <p>秒</p>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">每日一词:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入每日一词" v-model="item.keyword" style="height:140px;"></textarea>
              </div>
            </div>
          </div>

          <div style="display:block;" v-else-if="item.speech_type == 5">
            <div class="write-txt">
              <p class="write-title">关卡标题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入关卡标题" v-model="item.level_title" style="height:140px;"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">倒计时设置:<span>*</span></p>
              <div class="write-text">
                <input type="text" placeholder="请输入秒" v-model="item.preparation_time">
                <p>秒</p>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">演讲时长:<span>*</span></p>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入分钟" v-model="item.min_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.min_second">
                <p>秒</p>
              </div>
              <div class="write-text write-time">
                <!-- <input type="text" placeholder="请输入秒" style="opacity:0;"> -->
                <p style="line-height:65px">——</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_second">
                <p>秒</p>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">每日一词:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入每日一词" v-model="item.keyword" style="height:140px;"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">背景介绍:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入背景介绍" v-model="item.background" style="height:140px;"></textarea>
              </div>
            </div>

            <div class="video-list">
              <div class="video-item" v-for="(ele,num) in item.videos" :key="num"  v-loading="videoIndex===num" :element-loading-text="loadTxt">
                <div class="write-txt" >
                  <p class="write-title">上传视频{{(num+1)}}</p>
                  <div class="write-text">
                    <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="ele.video">
                      <video :src="'https://pic.speechcoach.cn/'+ele.video" alt=""></video>
                      <div class="hover hide" >
                        <i class="icon-delete" @click="imgRemove"></i>
                      </div>
                    </div>
                    <el-upload
                      :action="'https://upload.qiniup.com'"
                      :data="uploadObj"
                      list-type="picture-card"
                      :before-upload="beforeUploadVideo"
                      :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,num)}"
                      :on-progress="(response, file, fileList)=>{return handleProgressImg(response, file, fileList,item,num)}"
                      :on-remove="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,num)}"
                      :on-change="(file, fileList)=>{handleChangeVideo(file, fileList,item,num)}"
                      :on-error="(err, file, fileList)=>{handleErrorVideo(err, file, fileList,item,num)}"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        width="100%"
                        :src="'https://pic.bi-rong.com/' + ele.video"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div>

                <div class="write-txt">
                  <p class="write-title">视频文字稿:</p>
                  <div class="write-text">
                    <textarea placeholder="请输入视频文字稿" v-model="ele.video_cont" style="height:140px;"></textarea>
                  </div>
                </div>

                <button class="btn btn-video-add" @click="addVideo(item)">添加视频</button>
              </div>
            </div>

          </div>

          <div style="display:block;" v-else-if="item.speech_type == 1">
            <div class="write-txt">
              <p class="write-title">关卡标题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入关卡标题" v-model="item.level_title" style="height:140px;"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">倒计时设置:<span>*</span></p>
              <div class="write-text">
                <input type="text" placeholder="请输入秒" v-model="item.preparation_time">
                <p>秒</p>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">演讲时长:<span>*</span></p>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入分钟" v-model="item.min_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.min_second">
                <p>秒</p>
              </div>
              <div class="write-text write-time">
                <!-- <input type="text" placeholder="请输入秒" style="opacity:0;"> -->
                <p style="line-height:65px">——</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_minute">
                <p>分钟</p>
              </div>
              <div class="write-text write-time">
                <input type="text" placeholder="请输入秒" v-model="item.max_second">
                <p>秒</p>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">每日一词:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入每日一词" v-model="item.keyword" style="height:140px;"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">演讲主题:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入演讲主题" v-model="item.title" style="height:140px;"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">演讲内容:<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="请输入演讲内容" v-model="item.speech_cont" style="height:140px;"></textarea>
              </div>
            </div>

            <div class="write-txt">
              <p class="write-title">演讲时隐藏标题和演讲内容:<span>*</span></p>
              <div class="write-text">
                <el-radio-group v-model="item.is_hide">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="write-txt" v-loading="loadingImg" :element-loading-text="loadTxt">>
              <p class="write-title">上传图片</p>
              <div class="write-text" v-for="(ele,num) in item.images" :key="num" >
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="ele">
                  <img :src="'https://pic.speechcoach.cn/'+ele" alt="">
                  <div class="hover hide" >
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadImg"
                  :on-success="(response, file, fileList)=>{return handleSuccessImg(response, file, fileList,item,num)}"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveVideo"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://pic.bi-rong.com/' + ele"
                    alt=""
                  />
                </el-dialog>
              </div>
            </div>

            <div class="video-list">
              <div class="video-item" v-for="(ele,num) in item.videos" :key="num" v-loading="videoIndex===num" :element-loading-text="loadTxt">
                <div class="write-txt" >
                  <p class="write-title">上传视频{{(num+1)}}</p>
                  <div class="write-text">
                    <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="ele.video">
                      <video :src="'https://pic.speechcoach.cn/'+ele.video" alt=""></video>
                      <div class="hover hide" >
                        <i class="icon-delete" @click="imgRemove"></i>
                      </div>
                    </div>
                    <el-upload
                      :action="'https://upload.qiniup.com'"
                      :data="uploadObj"
                      list-type="picture-card"
                      :before-upload="beforeUploadVideo"
                      :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,num)}"
                      :on-progress="(response, file, fileList)=>{return handleProgressImg(response, file, fileList,item,num)}"
                      :on-remove="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,num)}"
                      :on-change="(file, fileList)=>{handleChangeVideo(file, fileList,item,num)}"
                      :on-error="(err, file, fileList)=>{handleErrorVideo(err, file, fileList,item,num)}"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        width="100%"
                        :src="'https://pic.bi-rong.com/' + ele.video"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div>

                <div class="write-txt">
                  <p class="write-title">视频文字稿:</p>
                  <div class="write-text">
                    <textarea placeholder="请输入视频文字稿" v-model="ele.video_cont" style="height:140px;"></textarea>
                  </div>
                </div>

                <button class="btn btn-video-add" @click="addVideo(item)">添加视频</button>
              </div>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">文字-演讲简易报告提示词:</p>
            <div class="write-text">
              <textarea placeholder="请输入文字-演讲简易报告提示词" v-model="item.ai_prompt_simple" style="height:140px;"></textarea>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">文字-演讲完整报告提示词:</p>
            <div class="write-text">
              <textarea placeholder="请输入文字-演讲完整报告提示词" v-model="item.ai_prompt" style="height:140px;"></textarea>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">演讲报告提示词-语音:</p>
            <div class="write-text">
              <textarea placeholder="请输入演讲报告提示词-语音" v-model="item.ai_prompt_audio" style="height:140px;"></textarea>
            </div>
          </div>

          <div class="write-txt">
            <p class="write-title">演讲报告提示词-视频:</p>
            <div class="write-text">
              <textarea placeholder="请输入演讲报告提示词-视频" v-model="item.ai_prompt_video" style="height:140px;"></textarea>
            </div>
          </div>

          <div class="write-txt" v-for="(ele,num) in item.ai_prompt_dim" :key="num">
              <p class="write-title">维度{{(num+1)}}:</p>
              <div class="write-text">
                <textarea v-model="item.ai_prompt_dim[num]"></textarea>
              </div>
            </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="levelSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.type==1?'自由型':'解锁型'">{{item.type==1?'自由型':'解锁型'}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildSub(item,'detail')">编辑</button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)">删除</button>
                <button title="关卡" class="btn btn-revise" @click="buildSub(item,'level')">关卡</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGameModelList,updateGameModelStatus,delGameModel,getGameModelDetail ,saveGameModel ,getUploadToken ,saveGameLevel} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'18',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'模块'},
        {id:3,title:'类型'},
        {id:4,title:'关卡数'},
        {id:5,title:'开启/关闭'},
        {id:6,title:'添加时间'},
        {id:7,title:'操作'},
      ],
      speechlist:[
        {id:1,title:'即兴演讲'},
        {id:2,title:'费曼练习'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        title:'',
        type:1,
        is_vip:0,
        sort:''
      },
      totalPage:0,
      removeID:'',
      url:'',
      fileUrl:'/static/词库导入表.xlsx',
      wordType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      loading:false,
      loadTxt:'',
      dialogVisible:false,
      imgType:false,
      speechType:[
        {id:1,title:'费曼练习'},
        {id:3,title:'备稿演讲'},
        {id:4,title:'即兴演讲'},
        {id:5,title:'演讲评估'},
        {id:7,title:'读稿'},
      ],
      levelObj:[],
      levelIndex:0,
      videoIndex:'',
      loadingImg:false,
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async switchChange(e){
      var that = this;
      var obj = {
        mid:e.mid,
        status:e.status==false?0:1,
      };
      try {
        const response = await updateGameModelStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },


    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
      
    },

    async getList(){
      var that = this;
      try {
        const response = await getGameModelList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            item.status = item.status == 1?true:false;
          });
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
      that.levelObj = [
        {
          level_title:'',
          num:1,
          preparation_time:'',
          speech_min_time:'',
          speech_max_time:'',
          keyword:'',
          title:'',
          speech_cont:'',
          is_hide:'0',
          images:[''],
          videos:[
            {video:'',video_cont:''}
          ],
          ai_prompt:'',
          ai_prompt_simple:'',
          ai_prompt_video:'',
          ai_prompt_audio:'',
          ai_prompt_dim:['','','','','']
        }
      ];
      this.addObj.type = JSON.stringify(this.addObj.type)
      this.addObj.is_vip = JSON.stringify(this.addObj.is_vip)
    },

    async buildSub(e,type){
      var that = this;
      try {
        const response = await getGameModelDetail({mid:e.mid},this.token);
        if(response.code == 200){
          if(type == 'level'){
            if(response.data.level.length === 0){
              that.levelObj = [
                {
                  num:1,
                  level_title:'',
                  speech_type:1,
                  preparation_time:'',
                  speech_min_time:'',
                  speech_max_time:'',
                  keyword:'',
                  title:'',
                  speech_cont:'',
                  is_hide:0,
                  images:[''],
                  videos:[
                    {video:'',video_cont:''}
                  ],
                  ai_prompt:'',
                  ai_prompt_simple:'',
                  ai_prompt_video:'',
                  ai_prompt_audio:'',
                  ai_prompt_dim:['','','','','']
                }
              ] 
            } else { 
              // 【新增】处理数据转换：将秒数转换为分+秒
              if (response.data.level && response.data.level.length > 0) {
                response.data.level.forEach(function(item) {
                  // 1. 处理最小演讲时长 (speech_min_time -> min_minute, min_second)
                  if (item.speech_min_time) {
                    const totalMinSec = parseInt(item.speech_min_time);
                    item.min_minute = Math.floor(totalMinSec / 60);
                    item.min_second = totalMinSec % 60;
                  } else {
                    // 如果没有值，初始化为空或0，防止显示undefined
                    item.min_minute = '';
                    item.min_second = '';
                  }

                  // 2. 处理最大演讲时长 (speech_max_time -> max_minute, max_second)
                  if (item.speech_max_time) {
                    const totalMaxSec = parseInt(item.speech_max_time);
                    item.max_minute = Math.floor(totalMaxSec / 60);
                    item.max_second = totalMaxSec % 60;
                  } else {
                    item.max_minute = '';
                    item.max_second = '';
                  }
                });
                
                // 将处理后的数据赋值给 that.levelObj
                that.levelObj = response.data.level;
              }
            };
            that.levelObj.forEach(function(item,index){ 
              if(item.ai_prompt_dim == null){
                item.ai_prompt_dim = ['','','','',''];
              }
                item.is_hide = JSON.stringify(item.is_hide)
            });
            that.addObj.mid = response.data.mid;
            that.wordType = type;
          } else {
            that.addObj = {
              title:response.data.title,
              type:JSON.stringify(response.data.type),
              is_vip:JSON.stringify(response.data.is_vip),
              sort:response.data.sort,
              mid:response.data.mid
            };
            that.addType = 'revise';
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    formatTime(seconds) {
      if (!seconds && seconds !== 0) return '0秒';
  
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      
      let result1 = '';
      let result2 = '';
      if (m > 0) {
        result1 += `${m}分`;
      }
      if (s > 0 || m === 0) {
        result2 += `${s}秒`;
      }
      return result1;
      return result2;
    },

    removeShow(e){
      this.removeID = e.mid;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delGameModel({mid:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.title == ''){
        that.$message('请输入模块名称！');
        return false;
      }
      
      try {
        const response = await saveGameModel(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {},
      this.wordType=false;
      this.levelObj = [];
      this.levelIndex = 0;
      this.videoIndex = '';
      this.loadingImg = false;
    },

    async levelSub(){
      var that = this;
      // 1. 先进行校验，如果校验失败直接返回，不执行保存逻辑
      for (var i = 0; i < this.levelObj.length; i++) {
        var item = this.levelObj[i];
        // 校验倒计时设置 (根据原有逻辑，似乎所有类型都需要校验，或者仅特定类型)
        // 注意：原代码中只判断了 speech_type == 1，这里保留原逻辑
        if (item.level_title == '' || item.level_title === null || item.level_title === undefined) {
          that.$message('请填写第' + (i + 1) + '关的关卡标题');
          return; // 直接终止函数执行
        }
        if (item.speech_type == 1) {
          if (item.preparation_time == '' || item.preparation_time === null || item.preparation_time === undefined) {
            that.$message('请填写第' + (i + 1) + '关的倒计时设置');
            return; // 直接终止函数执行
          }
          console.log(item,'item.min_minute')
          if (item.min_minute === '' || item.min_minute === null || item.min_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.min_second === '' || item.min_second === null || item.min_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长秒数');
            return; // 直接终止函数执行
          }
          if (item.max_minute === '' || item.max_minute === null || item.max_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.max_second === '' || item.max_second === null || item.max_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长秒数');
            return; // 直接终止函数执行
          }
          if (item.keyword == '' || item.keyword === null || item.keyword === undefined) {
            that.$message('请填写第' + (i + 1) + '关的每日一词');
            return; // 直接终止函数执行
          }
          if (item.title == '' || item.title === null || item.title === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲主题');
            return; // 直接终止函数执行
          }
          if (item.speech_cont == '' || item.speech_cont === null || item.speech_cont === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲内容');
            return; // 直接终止函数执行
          }
        }

        if (item.speech_type == 3) {
          if (item.preparation_time == '' || item.preparation_time === null || item.preparation_time === undefined) {
            that.$message('请填写第' + (i + 1) + '关的倒计时设置');
            return; // 直接终止函数执行
          }
          if (item.min_minute === '' || item.min_minute === null || item.min_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.min_second === '' || item.min_second === null || item.min_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长秒数');
            return; // 直接终止函数执行
          }
          if (item.max_minute === '' || item.max_minute === null || item.max_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.max_second === '' || item.max_second === null || item.max_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长秒数');
            return; // 直接终止函数执行
          }
          if (item.keyword == '' || item.keyword === null || item.keyword === undefined) {
            that.$message('请填写第' + (i + 1) + '关的每日一词');
            return; // 直接终止函数执行
          }
        }

        if (item.speech_type == 4) {
          if (item.title == '' || item.title === null || item.title === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲主题');
            return; // 直接终止函数执行
          }
          if (item.preparation_time == '' || item.preparation_time === null || item.preparation_time === undefined) {
            that.$message('请填写第' + (i + 1) + '关的倒计时设置');
            return; // 直接终止函数执行
          }
          if (item.min_minute === '' || item.min_minute === null || item.min_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.min_second === '' || item.min_second === null || item.min_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长秒数');
            return; // 直接终止函数执行
          }
          if (item.max_minute === '' || item.max_minute === null || item.max_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.max_second === '' || item.max_second === null || item.max_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长秒数');
            return; // 直接终止函数执行
          }
          if (item.keyword == '' || item.keyword === null || item.keyword === undefined) {
            that.$message('请填写第' + (i + 1) + '关的每日一词');
            return; // 直接终止函数执行
          }
        }

        if (item.speech_type == 5) {
          if (item.preparation_time == '' || item.preparation_time === null || item.preparation_time === undefined) {
            that.$message('请填写第' + (i + 1) + '关的倒计时设置');
            return; // 直接终止函数执行
          }
          if (item.min_minute === '' || item.min_minute === null || item.min_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.min_second === '' || item.min_second === null || item.min_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长秒数');
            return; // 直接终止函数执行
          }
          if (item.max_minute === '' || item.max_minute === null || item.max_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.max_second === '' || item.max_second === null || item.max_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长秒数');
            return; // 直接终止函数执行
          }
          if (item.keyword == '' || item.keyword === null || item.keyword === undefined) {
            that.$message('请填写第' + (i + 1) + '关的每日一词');
            return; // 直接终止函数执行
          }
          if (item.background == '' || item.background === null || item.background === undefined) {
            that.$message('请填写第' + (i + 1) + '关的背景介绍');
            return; // 直接终止函数执行
          }
        }

        if (item.speech_type == 7) {
          if (item.title == '' || item.title === null || item.title === undefined) {
            that.$message('请填写第' + (i + 1) + '关的标题');
            return; // 直接终止函数执行
          }
          if (item.speech_cont == '' || item.speech_cont === null || item.speech_cont === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲内容');
            return; // 直接终止函数执行
          }
          
          if (item.preparation_time == '' || item.preparation_time === null || item.preparation_time === undefined) {
            that.$message('请填写第' + (i + 1) + '关的倒计时设置');
            return; // 直接终止函数执行
          }
          if (item.min_minute === '' || item.min_minute === null || item.min_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.min_second === '' || item.min_second === null || item.min_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最短时长秒数');
            return; // 直接终止函数执行
          }
          if (item.max_minute === '' || item.max_minute === null || item.max_minute === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长分钟数');
            return; // 直接终止函数执行
          }
          if (item.max_second === '' || item.max_second === null || item.max_second === undefined) {
            that.$message('请填写第' + (i + 1) + '关的演讲时长最长时长秒数');
            return; // 直接终止函数执行
          }
        }
        if (item.ai_prompt_dim && Array.isArray(item.ai_prompt_dim)) {
          const allEmpty = item.ai_prompt_dim.every(dim => !dim || dim.trim() === '');
          
          if (allEmpty) {
            // 全为空，删除该参数
            delete item.ai_prompt_dim;
          } else {
            // 部分有值，保留。
            // 如果你希望在这种情况下也提示“请填写完整”，可以加上面的 hasEmpty 判断
             that.$message('第' + (i + 1) + '关维度如需填写，请五个维度都填写完整');
          }
        }
        
        // 可以在这里添加其他必填项校验...
      }

      // 2. 校验通过后，再处理数据转换和保存
      this.levelObj.forEach(function(item, index) {
        // 防止空值导致 NaN
        var minM = parseInt(item.min_minute) || 0;
        var minS = parseInt(item.min_second) || 0;
        var maxM = parseInt(item.max_minute) || 0;
        var maxS = parseInt(item.max_second) || 0;

        item.speech_min_time = minM * 60 + minS;
        item.speech_max_time = maxM * 60 + maxS;

        // 删除临时用于展示的字段
        delete item.min_minute;
        delete item.min_second;
        delete item.max_minute;
        delete item.max_second;
      });
      this.addObj.level = this.levelObj;
      try {
        const response = await saveGameLevel(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.loading = false;
        that.getList();
      } else {
        that.$message(response.msg);
      }
    },

    beforeUploadVideo(file) {
      // this.loading = true;
      // this.loadTxt = '上传中...';
      // this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填


      const isVideo = file.type.startsWith('video/');
      if (!isVideo) {
        this.$message('只能上传视频文件！');
        return false;
      }
      
      const maxSize = 500 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$message('视频大小不能超过 500MB！');
        return false;
      }
      
      if (!this.uploadObj.token) {
        this.$message('获取上传凭证失败，请刷新页面重试');
        this.getToken();
        return false;
      }
      
      this.loading = true;
      this.loadTxt = '上传中...';
      this.uploadObj.key = file.uid + '_' + file.name;
      
      return true;
    },

    beforeUploadImg(file) {
      this.loadingImg = true;
      this.loadTxt = '上传中...';
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList,item,num) {
      item.images[num] = response.key;
      this.loadingImg = false;
      this.uploadObj.key = "";
      this.loadTxt = '上传中...';
      this.$forceUpdate();
    },

    handleSuccessVideo(response, file, fileList,item,num) {
      // this.addObj.videos[index].video = response.key;
      // console.log(this.addObj.videos)
      // this.loading = false;
      // this.uploadObj.key = "";
      // this.loadingImg = false;
      // this.$forceUpdate();

      this.loading = false;
      this.uploadObj.key = "";
      
      if (response.code == 200 || response.key) {
        item.videos[num].video = response.key;
        this.$message('上传成功');
        this.$forceUpdate();
      } else {
        this.$message(response.msg || '上传失败');
      }

      this.videoIndex = '';
    },

    handleProgressImg(event, file, fileList,item,num) {
      this.videoIndex = num
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveVideo(response, file, fileList,index) {
      this.addObj.image = "";
    },

    handleChangeVideo(file, fileList, item, num) {
      // if (file.status === 'uploading') {
      //   // this.$set(item.videos[num], 'uploading', true);
      //   item.uploading = true
      // console.log(item,'item')
      // } else if (file.status === 'success' || file.status === 'fail') {
      //   // this.$set(item.videos[num], 'uploading', false);
      //   item.uploading = false
      // }
      // this.$forceUpdate();
    },
    handleErrorVideo(err, file, fileList, item, num) {
      this.$set(item.videos[num], 'uploading', false);
      this.$message('上传失败');
      this.uploadObj.key = "";
      this.$forceUpdate();
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(index){
      this.addObj.images.splice(index,1);
      this.$forceUpdate();
    },

    videoAdd(){
      this.addObj.videos.push({video:'',video_cont:''});
      this.$forceUpdate();
    },

    videoRemove(index){ 
      this.addObj.videos.splice(index,1);
      this.$forceUpdate();
    },

    speechChnage(item,e,index){
      var that = this;
      let newObj = {}; // 定义新对象
      if(e == 1){
        newObj = {
          num:item.num,
          level_title:'',
          speech_type:1,
          preparation_time:'',
          min_minute:'',
          min_second:'',
          max_minute:'',
          max_second:'',
          speech_min_time:'',
          speech_max_time:'',
          keyword:'',
          title:'',
          speech_cont:'',
          is_hide:'0',
          images:[''],
          videos:[
            {video:'',video_cont:''}
          ],
          ai_prompt:'',
          ai_prompt_simple:'',
          ai_prompt_video:'',
          ai_prompt_audio:'',
          ai_prompt_dim:['','','','','']
        }
      } else if(e == 3){
        newObj = {
          num:item.num,
          level_title:'',
          speech_type:3,
          preparation_time:'',
          min_minute:'',
          min_second:'',
          max_minute:'',
          max_second:'',
          speech_min_time:'',
          speech_max_time:'',
          keyword:'',
          is_hide:'0',

          ai_prompt_simple:'',
          ai_prompt:'',
          ai_prompt_audio:'',
          ai_prompt_video:'',
          ai_prompt_dim:['','','','','']
        }
      } else if(e == 4){
      newObj = {
          num:item.num,
          level_title:'',
          speech_type:4,
          title:'',
          preparation_time:'',
          min_minute:'',
          min_second:'',
          max_minute:'',
          max_second:'',
          speech_min_time:'',
          speech_max_time:'',
          keyword:'',

          ai_prompt_simple:'',
          ai_prompt:'',
          ai_prompt_audio:'',
          ai_prompt_video:'',
          ai_prompt_dim:['','','','','']
        }
      } else if(e == 5){
      newObj = {
          num:item.num,
          speech_type:5,
          level_title:'',
          preparation_time:'',
          min_minute:'',
          min_second:'',
          max_minute:'',
          max_second:'',
          speech_min_time:'',
          speech_max_time:'',
          keyword:'',
          background:'',
          videos:[
            {video:'',video_cont:''}
          ],
          ai_prompt_simple:'',
          ai_prompt:'',
          ai_prompt_audio:'',
          ai_prompt_video:'',
          ai_prompt_dim:['','','','','']
        }
      } else if(e == 7){
      newObj = {
          num:item.num,
          speech_type:7,
          level_title:'',
          title:'',
          speech_cont:'',
          preparation_time:'',
          min_minute:'',
          min_second:'',
          max_minute:'',
          max_second:'',
          speech_min_time:'',
          speech_max_time:'',

          ai_prompt_simple:'',
          ai_prompt:'',
          ai_prompt_audio:'',
          ai_prompt_video:'',
          ai_prompt_dim:['','','','','']
        }
      }
      this.$set(this.levelObj, index, newObj);
      this.$forceUpdate();
      console.log(this.levelObj,'==examObj==')
    },

    addVideo(item){
      item.videos.push({video:'',video_cont:''});
      this.$forceUpdate();
    },

    levelAdd(){
      this.levelObj.push(
        {
          num:parseInt(this.levelObj.length)+1,
          level_title:'',
          speech_type:1,
          preparation_time:'',
          min_minute:'',
          min_second:'',
          max_minute:'',
          max_second:'',
          speech_min_time:'',
          speech_max_time:'',
          keyword:'',
          title:'',
          speech_cont:'',
          is_hide:'0',
          images:[''],
          videos:[
            {video:'',video_cont:''}
          ],
          ai_prompt:'',
          ai_prompt_simple:'',
          ai_prompt_video:'',
          ai_prompt_audio:'',
          ai_prompt_dim:['','','','','']
        }
      );
      this.$forceUpdate();
    },

    levelNum(index){
      this.levelIndex = index;
    },

    
    
  }

  

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 7 );
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .dataList .listItem p .btn{
    display: inline-block;
    vertical-align: top;
    color: #6E2FFF;
  }

  .dataList .listItem p .btn.btn-remove{
    color: #E2231A;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-txt .write-text.write-time {
    display: inline-block;
    vertical-align: top;
    width: auto;
  }

  .MobelBox .write-txt .write-text p{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: middle;
    margin-left: 30px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 300px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox input{
    width: 140px;
    height: 65px;
    vertical-align: middle;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .btn-import{
    display: inline-block;
    vertical-align: top;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-word-add{
    color: #6E2FFF;
    border: solid 1px #6E2FFF;
    border-radius: 8px;
    padding: 11px 34px;
    display: block;
    margin-top: 30px;
    font-size: 18px;
  }

  .btn-word-remove{
    background-color: #E2231A;
    border-radius: 8px;
    color: #fff;
    box-sizing: border-box;
    padding: 11px 52px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
  }

  .wordBox{
    height: calc( 100% - 100px );
  }

  .wordBox .write-num {
    margin-bottom: 30px;
    display: inline-block;
    vertical-align: top;
  }

  .wordBox .write-num p{
    display: inline-block;
    vertical-align: top;
    font-size: 18px;
    background-color: #F5F5F5;
    border-radius: 6px;
    color: #999999;
    padding: 9px 30px;
    box-sizing: border-box;
    margin-right: 30px;
  }

  .wordBox .write-num.select p{
    color: #fff;
    background-color: #6E2FFF;
  }

  .wordBox .btn-level{
    color: #6E2FFF;
    font-size: 18px;
    padding: 8px;
    border: solid 2px #6E2FFF;
    border-radius: 6px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-video-remove{
    display: inline-block;
    vertical-align: top;
    width: 120px;
    height: 56px;
    border-radius: 16px;
    line-height: 56px;
    margin: 0 20px;
    background-color: #6E2FFF;
    font-size: 20px;
    color: #fff;
  }

  .btn-video-remove{
    background-color: #E2231A;
  }

  .write-text .img .hover{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    position: absolute;
    top: 0;
    left: 0;
  }

  .write-text .img .icon-delete{
    background-image: url(~@/assets/images/btn-remove.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  
  .write-text>>> .el-radio-group{
    display: inline-block;
    vertical-align: top;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .btn-video-add{
    display: block;
    color: #6E2FFF;
    font-size: 18px;
    border: solid 1px #6E2FFF;
    border-radius: 8px;
    margin: 20px 0;
    box-sizing: border-box;
    padding: 11px 34px;
  }
</style>



// WEBPACK FOOTER //
// src/breakthrough/index.vue